(function () {
  'use strict';

  if (window.FLAV_FLAGS?.stickyAtc === false) return;
  if (!('IntersectionObserver' in window)) return;

  function initStickyAtc() {
    var pdp = document.querySelector('.flav-pdp');
    var mainAtc = document.getElementById('flav-main-atc');
    var form = mainAtc?.closest('form');

    if (!pdp || !mainAtc || document.querySelector('[data-flav-sticky-atc]')) return;

    var titleSource = pdp.querySelector('.flav-pdp__title');
    var addedTimer = 0;
    var isVisible = false;

    var bar = document.createElement('div');
    bar.className = 'flav-sticky-atc';
    bar.setAttribute('data-flav-sticky-atc', '');
    bar.setAttribute('aria-hidden', 'true');

    bar.innerHTML = [
      '<div class="flav-sticky-atc__inner">',
      '  <div class="flav-sticky-atc__summary">',
      '    <p class="flav-sticky-atc__title"></p>',
      '    <div class="flav-sticky-atc__meta">',
      '      <span class="flav-sticky-atc__price" data-sticky-atc-price></span>',
      '      <span class="flav-sticky-atc__badge" data-sticky-atc-badge hidden>Subscribe</span>',
      '    </div>',
      '  </div>',
      '  <button type="button" class="flav-sticky-atc__button" data-sticky-atc-button>Add to Cart</button>',
      '</div>'
    ].join('');

    document.body.appendChild(bar);

    var titleEl = bar.querySelector('.flav-sticky-atc__title');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var badgeEl = bar.querySelector('[data-sticky-atc-badge]');
    var buttonEl = bar.querySelector('[data-sticky-atc-button]');

    function getScrollTarget() {
      return form || mainAtc;
    }

    function getTitle() {
      return (titleSource?.textContent || pdp.getAttribute('aria-label') || document.title || '').trim();
    }

    function getSellingPlanInput() {
      return pdp.querySelector('[data-selling-plan-input]');
    }

    function getButtonTextSource() {
      return mainAtc.querySelector('.flav-pdp__button-text');
    }

    function getPriceSource() {
      return mainAtc.querySelector('[data-cart-price]') || pdp.querySelector('[data-cart-price]');
    }

    function getPrice() {
      var priceSource = getPriceSource();
      return (priceSource?.textContent || '').trim();
    }

    function isSubscribed() {
      var sellingPlanInput = getSellingPlanInput();

      if (sellingPlanInput instanceof HTMLInputElement) {
        return sellingPlanInput.value.trim() !== '';
      }

      var checked = pdp.querySelector('input[name="purchase_type"]:checked');
      return checked?.value === 'subscribe';
    }

    function isSoldOut() {
      return /sold\s*out/i.test((mainAtc.textContent || '').trim()) && !mainAtc.querySelector('[data-cart-price]');
    }

    function getButtonLabel() {
      if (isSoldOut()) return 'Sold Out';
      return 'Go to Add to Cart';
    }

    function setVisible(nextVisible) {
      if (isVisible === nextVisible) return;
      isVisible = nextVisible;
      bar.classList.toggle('is-visible', nextVisible);
      bar.setAttribute('aria-hidden', nextVisible ? 'false' : 'true');
    }

    function syncState() {
      var soldOut = isSoldOut();
      var price = getPrice();
      var label = getButtonLabel();

      if (titleEl) {
        titleEl.textContent = getTitle();
      }

      if (priceEl) {
        priceEl.textContent = price;
        priceEl.hidden = !price;
      }

      if (badgeEl) {
        var subscribed = isSubscribed() && !soldOut;
        badgeEl.hidden = !subscribed;
      }

      if (buttonEl) {
        buttonEl.textContent = label;
        buttonEl.disabled = mainAtc.disabled;
        buttonEl.classList.toggle('is-disabled', mainAtc.disabled);
      }

      bar.classList.toggle('is-sold-out', soldOut);
    }

    function showAddedFeedback() {
      if (!(buttonEl instanceof HTMLButtonElement)) return;

      window.clearTimeout(addedTimer);
      buttonEl.textContent = 'Scroll to Add';
      bar.classList.add('is-added');

      addedTimer = window.setTimeout(function () {
        bar.classList.remove('is-added');
        syncState();
      }, 1000);
    }

    function handleProxyClick() {
      if (!(buttonEl instanceof HTMLButtonElement) || buttonEl.disabled) return;

      var scrollTarget = getScrollTarget();
      if (!(scrollTarget instanceof Element)) return;

      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });

      window.setTimeout(function () {
        if (mainAtc instanceof HTMLButtonElement && !mainAtc.disabled) {
          mainAtc.focus({ preventScroll: true });
        }
      }, 250);

      showAddedFeedback();
    }

    buttonEl?.addEventListener('click', handleProxyClick);

    var visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting);
      });
    }, { threshold: 0 });

    visibilityObserver.observe(mainAtc);

    var mainObserver = new MutationObserver(function () {
      syncState();
    });

    mainObserver.observe(mainAtc, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy', 'class'],
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.flav-pdp')) return;

      if (
        target.matches('input[name="purchase_type"]') ||
        target.matches('[data-selling-plan-select]') ||
        target.matches('[data-variant-id]') ||
        target.matches('input[name="id"]')
      ) {
        window.requestAnimationFrame(syncState);
      }
    });

    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc, { once: true });
  } else {
    initStickyAtc();
  }
})();
